import React from 'react'
import MaterialSymbol from '../material-symbol'

const Send = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="send" {...props} />
))

Send.displayName = 'Send'

export default Send
